interface IntercomUserTraits {
  userId: string
  email?: string
  name?: string
  tenantId?: string
  tenantName?: string
}

let _appId: string | undefined | null = null
const getAppId = (): string | undefined => {
  if (_appId === null) {
    _appId = useRuntimeConfig().public.intercomAppId as string | undefined
  }
  return _appId
}

export default function useIntercom () {
  const appId = getAppId()

  const isEnabled = () => !!appId && typeof window.Intercom === 'function'

  // Associate the widget with a logged-in user and show the launcher.
  // Call when user information is available; include tenant fields when
  // corresponding tenant data has been loaded so company data is populated.
  const identify = ({ userId, email, name, tenantId, tenantName }: IntercomUserTraits) => {
    if (!isEnabled()) { return }
    window.Intercom('update', {
      app_id: appId,
      user_id: userId,
      email,
      name,
      hide_default_launcher: false,
      ...(tenantId && {
        company: tenantName
          ? { company_id: tenantId, name: tenantName }
          : { company_id: tenantId }
      })
    })
  }

  // Clear the session on logout. Re-boots hidden so the launcher is not shown
  // on public pages (e.g. login).
  const shutdown = () => {
    if (!isEnabled()) { return }
    window.Intercom('shutdown')
    window.Intercom('boot', { app_id: appId, hide_default_launcher: true })
  }

  return { identify, shutdown }
}
